import {
  GetEmployeesQuery,
  GetEmployeesQueryVariables,
  useGetEmployeesQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export const cacheKey = "GetEmployees";

export default function useGetEmployees({
  page = 1,
  first = 10,
  search,
  sort,
}: GetEmployeesQueryVariables) {
  const {
    data: graphqlData,
    loading,
    error,
    fetchMore: more,
  } = useGetEmployeesQuery({
    variables: {
      page,
      first,
      search,
      sort,
    },
  });

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  const getData = useCallback(({ data }: { data?: GetEmployeesQuery }) => {
    return data?.getEmployees?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data?: GetEmployeesQuery }) => {
    return data?.getEmployees?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData]);

  return { data, loading, error, paginatorInfo, fetchMore, getData, getPaginatorInfo } as const;
}
